import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CommonService } from '../core/services/common.service';


@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit {
  Bindvalue: any;
  constructor(
    public _service: CommonService,
    public dialogRef: MatDialogRef<PopupComponent>) { }

  ngOnInit() {
    this.Bindvalue = this._service.GetpopupData;
    //console.dir(this._service.GetpopupData);
  }

  onNoClick(data) {
    this.dialogRef.close(data);
  }

}
